import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiHeart } from "react-icons/fi";
import "../css/main.scss";
import productData, { siteConfig } from "../Datas/productData";
import { CartContext } from "./CartContext";

function Main() {
  const { toggleWishlist, isInWishlist } = useContext(CartContext);
  const featuredProducts = productData.filter((product) => product.featured).slice(0, 3);
  const editorialProduct = productData[14];

  return (
    <div className="home-page">
      <main>
        <section className="home-collection" aria-labelledby="collection-title">
          <header className="home-section-heading">
            <p className="eyebrow">Assemblage I · 2026</p>
            <h1 id="collection-title">KOLLEKTION EINS</h1>
            <p>The new cravat merges jewellery, sculpture and neckwear.</p>
          </header>

          <div className="home-product-grid">
            {featuredProducts.map((product, index) => (
              <article className="home-product-card" key={product.id}>
                <Link className="home-product-card__image" to={`/shopDetails/${product.id}`}>
                  <img
                    src={product.image}
                    alt={product.name}
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                  <span>View piece</span>
                </Link>
                <div className="home-product-card__info">
                  <div>
                    <p>{product.category}</p>
                    <h2>
                      <Link to={`/shopDetails/${product.id}`}>{product.name}</Link>
                    </h2>
                    <span>
                      {siteConfig.currency.symbol}{product.price.toFixed(2)} {siteConfig.currency.code}
                    </span>
                  </div>
                  <button
                    type="button"
                    className={isInWishlist(product.id) ? "is-active" : ""}
                    aria-label={
                      isInWishlist(product.id)
                        ? `Remove ${product.name} from wishlist`
                        : `Add ${product.name} to wishlist`
                    }
                    onClick={() => toggleWishlist(product.id)}
                  >
                    <FiHeart aria-hidden="true" />
                  </button>
                </div>
              </article>
            ))}
          </div>

          <Link className="text-link" to="/shop">
            Discover the complete assemblage <FiArrowUpRight aria-hidden="true" />
          </Link>
        </section>

        <section className="home-influence" aria-labelledby="influence-title">
          <div className="home-influence__image">
            <img
              src="/main/editorial-arcade.jpg"
              alt="Two models wearing contemporary sculptural neckwear in a stone arcade"
              loading="lazy"
            />
          </div>
          <div className="home-influence__copy">
            <div>
              <p className="eyebrow">Past, worn forward</p>
              <h2 id="influence-title">1920s FASHION INFLUENCE</h2>
            </div>
            <div>
              <p>
                The twenties paired elegance with a newly found practicality. Rules loosened,
                silhouettes shifted, and style became a language of individuality in the city.
              </p>
              <p>
                We bring that assured spirit into the present: the precision of an evening
                wardrobe with the ease of contemporary street culture. Every piece is designed
                to be personal, adaptable and worn without ceremony.
              </p>
              <Link className="text-link text-link--light" to="/about">
                Enter the atelier <FiArrowUpRight aria-hidden="true" />
              </Link>
            </div>
          </div>
        </section>

        <section className="home-journal" id="journal" aria-labelledby="journal-title">
          <header>
            <p className="eyebrow">Selections & notes</p>
            <h2 id="journal-title">From the atelier</h2>
          </header>

          <div className="home-journal__grid">
            <article className="home-journal__product">
              <Link to={`/shopDetails/${editorialProduct.id}`}>
                <img src={editorialProduct.image} alt={editorialProduct.name} loading="lazy" />
              </Link>
              <div>
                <p className="eyebrow">The season's object</p>
                <h3>{editorialProduct.name}</h3>
                <p>
                  A quietly luminous silk piece that changes character with every shirt and
                  every hour of the day.
                </p>
                <Link className="text-link" to={`/shopDetails/${editorialProduct.id}`}>
                  View the piece <FiArrowUpRight aria-hidden="true" />
                </Link>
              </div>
            </article>

            <article className="home-journal__story">
              <img
                src="/main/atelier-craft.jpg"
                alt="Artisan hands cutting deep blue silk in the atelier"
                loading="lazy"
              />
              <div>
                <p className="eyebrow">Journal No. 01</p>
                <h3>The patience of a permanent pleat</h3>
                <p>
                  Each line is shaped, rested and finished by hand. A short note on why slow
                  construction gives silk its unmistakable movement.
                </p>
                <Link className="text-link text-link--light" to="/about">
                  Read the story <FiArrowUpRight aria-hidden="true" />
                </Link>
              </div>
            </article>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Main;
